import { useEditor, EditorContent, EditorOptions, Editor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material';
import { Button } from './TiptapMuiButtonNode';

const extensions = [
  StarterKit,
  Image.configure({
    HTMLAttributes: {
      class: 'tiptap-image',
    },
  }),
  Link.configure({
    validate: (href) => /^https?:\/\//.test(href),
  }),
  Button,
];

export const useTiptap = (options: Partial<EditorOptions> = {}) =>
  useEditor({
    extensions,
    ...options,
  });

type TiptapEditorProps = {
  editor: Editor | null;
  styles?: SxProps<Theme>;
};

export const TiptapEditor = (props: TiptapEditorProps) => (
  <Box
    sx={{
      'p:first-child': {
        marginTop: 0,
      },
      'p:last-child': {
        marginBottom: 0,
      },
      blockquote: {
        borderLeft: '2px solid',
        margin: 0,
        padding: (theme: Theme) => `${theme.spacing(1)} ${theme.spacing(2)}`,
        borderColor: (theme: Theme) => theme.palette.grey[400],
        color: (theme: Theme) => theme.palette.grey[600],
      },
      ol: {
        paddingInlineStart: (theme: Theme) => theme.spacing(3),
      },
      ul: {
        paddingInlineStart: (theme: Theme) => theme.spacing(3),
      },
      ...props.styles,
    }}
  >
    <EditorContent editor={props.editor} />
  </Box>
);
